import { useQuery } from '@tanstack/react-query';
import { QUERIES } from '../utils/constants';
import { getRetailerSettingsQueryFn } from '../graphql/query/getRetailerSettings';

export const useRetailerSettings = () => {
  const { data, isError, isLoading, error } = useQuery({
    queryKey: [QUERIES.GET_RETAILER_SETTINGS],
    queryFn: getRetailerSettingsQueryFn,
    retry: false,
    retryOnMount: false,
  });

  return {
    ...data?.retailerSettings,
    isError,
    isLoading,
    error,
  };
};
